import React from 'react';
import '../../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import cx from 'classnames';
import '../../../../common/GradientWrapper/index.js';
import '../../../../common/Icon/index.js';
import { LazyImage } from '../../../../common/LazyImage/index.js';
import '../../../../common/NumberFormat/index.js';
import '../../../../common/WithCustomScrollbar/index.js';
import styles from './index.module.scss.js';

const getClasses = (isFocused, isSelected) => {
  let classes = "select__option";
  if (isFocused) classes += " select__option--focused";
  if (isSelected) classes += " select__option--selected";
  return classes;
};
const Option = ({
  className,
  style,
  name,
  value,
  bet,
  icon,
  $kind,
  $isFocused,
  $isSelected,
  $theme,
  labelBet = "Bet"
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: `${getClasses($isFocused, $isSelected)} ${className || ""} ${cx(
      styles.box,
      "select__option",
      {
        [styles[$kind]]: $kind,
        [styles.focused]: $isFocused,
        [styles.selected]: $isSelected,
        [styles[$theme || ""]]: !!$theme
      }
    )}`,
    style
  },
  /* @__PURE__ */ React.createElement("div", { className: cx(styles.left, "select__option-left") }, icon && /* @__PURE__ */ React.createElement("div", { className: cx(styles["image-container"], "select__option-icon") }, /* @__PURE__ */ React.createElement(LazyImage, { src: icon, alt: name, loading: "eager" })), /* @__PURE__ */ React.createElement("div", { className: cx(styles.name, "select__option-name") }, name)),
  value && /* @__PURE__ */ React.createElement("div", { className: cx(styles["value-box"], "select__option-right") }, /* @__PURE__ */ React.createElement("div", { className: styles.value }, value), bet && /* @__PURE__ */ React.createElement("div", { className: styles.bet }, labelBet, "\xA0", /* @__PURE__ */ React.createElement("div", { className: styles["current-bet"] }, bet.current), " /", /* @__PURE__ */ React.createElement("div", { className: styles["max-bet"] }, bet.max)))
);

export { Option };
//# sourceMappingURL=index.js.map
